export const SHOW_LOGIN_MODAL = 'SHOW_LOGIN_MODAL'
export const CLOSE_LOGIN_MODAL = 'CLOSE_LOGIN_MODAL'
export const SWITCH_TO_REGISTER = 'SWITCH_TO_REGISTER'
export const SWITCH_TO_LOGIN = 'SWITCH_TO_LOGIN'
export const SWITCH_TO_REGISTER_WITH_INVITATION = 'SWITCH_TO_REGISTER_WITH_INVITATION'
export const SWITCH_TO_FORGOT_PASSWORD = 'SWITCH_TO_FORGOT_PASSWORD'
export const SWITCH_TO_FORGOT_PASSWORD_CONFIRMATION = 'SWITCH_TO_FORGOT_PASSWORD_CONFIRMATION'
export const UPDATE_LOGIN_FIELD = 'UPDATE_LOGIN_FIELD'
export const UPDATE_REGISTER_FIELD = 'UPDATE_REGISTER_FIELD'
export const UPDATE_REGISTER_WITH_INVITATION_FIELD = 'UPDATE_REGISTER_WITH_INVITATION_FIELD'
export const UPDATE_FORGOT_PASSWORD_FIELD = 'UPDATE_FORGOT_PASSWORD_FIELD'
export const UPDATE_RESET_PASSWORD_FIELD = 'UPDATE_RESET_PASSWORD_FIELD'
export const UPDATE_LOGIN_ERROR = 'UPDATE_LOGIN_ERROR'
export const UPDATE_REGISTER_ERROR = 'UPDATE_REGISTER_ERROR'
export const UPDATE_FORGOT_PASSWORD_ERROR = 'UPDATE_FORGOT_PASSWORD_ERROR'
export const UPDATE_RESET_PASSWORD_ERROR = 'UPDATE_RESET_PASSWORD_ERROR'
export const START_LINKEDIN = 'START_LINKEDIN'

export const startLinkedinFlow = () => ({
	type: START_LINKEDIN
})

export const showLoginModal = () => ({
  type: SHOW_LOGIN_MODAL
})

export const closeLoginModal = () => ({
  type: CLOSE_LOGIN_MODAL
})

export const switchToRegister = () => ({
  type: SWITCH_TO_REGISTER
})

export const switchToLogin = () => ({
  type: SWITCH_TO_LOGIN
})

export const switchToRegisterWithInvitation = () => ({
  type: SWITCH_TO_REGISTER_WITH_INVITATION
})

export const switchToForgotPassword = () => ({
  type: SWITCH_TO_FORGOT_PASSWORD
})

export const switchToForgotPasswordConfirmation = (message) => ({
  confirmMessage: message,
  type: SWITCH_TO_FORGOT_PASSWORD_CONFIRMATION
})

export const updateLoginField = (name, value) => ({
  type: UPDATE_LOGIN_FIELD,
  name: name,
  value: value
})

export const updateRegisterField = (name, value) => ({
  type: UPDATE_REGISTER_FIELD,
  name: name,
  value: value
})

export const updateRegisterWithInvitationField = (name, value) => ({
  type: UPDATE_REGISTER_WITH_INVITATION_FIELD,
  name: name,
  value: value
})

export const updateForgotPasswordField = (name, value) => ({
  type: UPDATE_FORGOT_PASSWORD_FIELD,
  name: name,
  value: value
})

export const updateResetPasswordField = (name, value) => ({
  type: UPDATE_RESET_PASSWORD_FIELD,
  name: name,
  value: value
})

export const updateLoginError = (error) => ({
	type: UPDATE_LOGIN_ERROR,
	error: error
})

export const updateRegisterError = (error) => ({
	type: UPDATE_REGISTER_ERROR,
	error: error
})

export const updateForgotPasswordError = (error) => ({
  type: UPDATE_FORGOT_PASSWORD_ERROR,
  error: error
})

export const updateResetPasswordError = (error) => ({
  type: UPDATE_RESET_PASSWORD_ERROR,
  error: error
})



// WEBPACK FOOTER //
// ./src/actions/login.js